import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import get from 'immutable-less/transmute/get';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import ObjectTypeIcons, { DEFAULT_ICON } from 'automation-ui-action-features/constants/ObjectTypeIcons';
import * as SimulatedEnrollmentResultTypes from 'automation-ui-canvas/constants/SimulatedEnrollmentResultTypes';
import PreviewCard from 'automation-ui-canvas/components/test-flow/PreviewCard';
import PreviewBadge from 'automation-ui-canvas/components/test-flow/PreviewBadge';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
import { EnrollTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { jsx as _jsx } from "react/jsx-runtime";
class EnrollmentActionPreview extends Component {
  renderHeader() {
    const {
      flowObjectTypeId
    } = this.props;
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "enrollment.canvas.header_cob",
      objectTypeId: flowObjectTypeId
    });
  }
  renderBadge() {
    const {
      simulatedEnrollmentResult,
      onEnrollmentOverrideChange,
      overridden
    } = this.props;
    const enrolled = simulatedEnrollmentResult === SimulatedEnrollmentResultTypes.WOULD_ENROLL;
    const showOptions = overridden || !enrolled;
    const options = showOptions ? [{
      text: I18n.text('platformTest.badges.enrollment.enrolls'),
      value: true
    }, {
      text: I18n.text('platformTest.badges.enrollment.doesNotEnroll'),
      value: false
    }] : null;
    return /*#__PURE__*/_jsx(PreviewBadge, {
      use: enrolled ? 'yes' : 'no',
      onChange: onEnrollmentOverrideChange,
      value: enrolled,
      options: options,
      children: enrolled ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformTest.badges.enrollment.enrolls"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformTest.badges.enrollment.doesNotEnroll"
      })
    });
  }
  renderContent() {
    const {
      simulatedEnrollmentResult,
      logEvent,
      flowObjectTypeId,
      objectId,
      isEventTriggers
    } = this.props;
    const objectName = /*#__PURE__*/_jsx(ObjectNameReference, {
      id: objectId,
      objectTypeId: flowObjectTypeId
    });
    switch (simulatedEnrollmentResult) {
      case SimulatedEnrollmentResultTypes.WOULD_ENROLL:
        {
          if (isEventTriggers) {
            return /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "action-features.enrollment.actionPreview.WOULD_ENROLL_EVENT",
              options: {
                objectName
              }
            });
          }
          const manuallyEnrolled = get(LogEventKeys.ENROLL_TYPE, logEvent) === EnrollTypes.MANUAL_ENROLL;
          return manuallyEnrolled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "action-features.enrollment.actionPreview.WOULD_ENROLL_MANUALLY",
            options: {
              objectName
            }
          }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "action-features.enrollment.actionPreview.WOULD_ENROLL",
            options: {
              objectName
            }
          });
        }
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_NO_STARTING_LIST:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_NO_STARTING_LIST",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_NOT_IN_STARTING_LIST:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_NOT_IN_STARTING_LIST",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_IN_SUPPRESSION_LIST:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_IN_SUPPRESSION_LIST",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_IN_GOAL_LIST:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_IN_GOAL_LIST",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_CURRENTLY_ENROLLED:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_CURRENTLY_ENROLLED",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_ALREADY_FINISHED_AN_ENROLLMENT:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_ALREADY_FINISHED_AN_ENROLLMENT",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_INVALID_ANCHOR_PROPERTY_VALUE:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_INVALID_ANCHOR_PROPERTY_VALUE",
          options: {
            objectName
          }
        });
      case SimulatedEnrollmentResultTypes.WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST",
          options: {
            objectName
          }
        });
      default:
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "action-features.enrollment.actionPreview.UNKNOWN_TRY_AGAIN",
          options: {
            objectName
          }
        });
    }
  }
  render() {
    const {
      flowObjectTypeId,
      logEvent
    } = this.props;
    return /*#__PURE__*/_jsx(PreviewCard, {
      theme: "koala",
      icon: ObjectTypeIcons[flowObjectTypeId] || DEFAULT_ICON,
      header: this.renderHeader(),
      badge: this.renderBadge(),
      content: this.renderContent(),
      timestamp: logEvent && logEvent.timestamp,
      "data-test-id": "test-enrollment-action-preview"
    });
  }
}
export default EnrollmentActionPreview;